import { environment } from '../../../environments/environment';

export class BaseService {
    protected getFullUrl(url): string {
        return environment.apiEndpoint + url;
    }
}
